import type { Monaco } from '@monaco-editor/react';

import { KnzDiagnostic } from '../types';
import { KnzTextModel } from './types';

const MARKER_OWNER = 'knz';

/**
 * パースで得た診断を Monaco の marker（赤/黄波線）に反映する。
 * Error=赤波線、Warning=黄波線。
 */
export const setKnzMarkers = (
  monaco: Monaco,
  model: KnzTextModel,
  diagnostics: KnzDiagnostic[],
): void => {
  const markers = diagnostics.map((d) => {
    const lineContent = model.getLineContent(Math.min(d.line, model.getLineCount())) ?? '';
    return {
      severity:
        d.severity === 'error' ? monaco.MarkerSeverity.Error : monaco.MarkerSeverity.Warning,
      message: d.message,
      startLineNumber: d.line,
      startColumn: d.column ?? 1,
      endLineNumber: d.line,
      endColumn: d.endColumn ?? Math.max(2, lineContent.length + 1),
    };
  });
  monaco.editor.setModelMarkers(model, MARKER_OWNER, markers);
};

/** marker をクリアする */
export const clearKnzMarkers = (monaco: Monaco, model: KnzTextModel): void => {
  monaco.editor.setModelMarkers(model, MARKER_OWNER, []);
};
